'use strict';

const gtm = require('./modules/google').tagManager;

function isGreenFridaySite() {
    const headerLogo = $('.js-header-logo');
    const href = headerLogo.length > 0 && headerLogo[0].href;
    if (href) {
        return href.includes('greenfriday');
    }
    return false;
}

// This function is used for pushing data for:
// - product explanation slider (slick-slider.js)
function pushDataLayerData(eventCategory, eventAction, eventLabel) {
    if (!eventCategory || !eventAction || !eventLabel || !isGreenFridaySite()) {
        return;
    }

    const dataLayerData = {
        'event': 'green_friday',
        'event_category': eventCategory,
        'event_action': eventAction,
        'event_label': eventLabel
    };

    gtm.pushDataLayerEvent(dataLayerData);
}

function pushDataLayerDataForFAQBlock(eventLabel) {
    if (!eventLabel || !isGreenFridaySite()) {
        return;
    }

    const dataLayerData = {
        'event': 'green_friday',
        'event_category': 'faq',
        'event_action': 'click faq',
        'event_label': eventLabel
    };

    gtm.pushDataLayerEvent(dataLayerData);
}

const greenfriday = {
    pushDataLayerData: pushDataLayerData,
    pushDataLayerDataForFAQBlock: pushDataLayerDataForFAQBlock
};

module.exports = greenfriday;
